import { baseElementSchema } from "@/Components/Exercises/Elements/base";
import { stringReturnOpSchema } from "@/Components/Exercises/LogicOperation";
import { z } from "zod";

export const infoElementSchema = baseElementSchema.extend({
    type: z.literal("info"),
    text: z.union([z.string(), stringReturnOpSchema]).optional(),
});
export const infoElementDataSchema = z.object({});
export type InfoElement = z.infer<typeof infoElementSchema>;
export type InfoElementData = z.infer<typeof infoElementDataSchema>;
